import { assign, createMachine } from "xstate"

const initialContext = {
  idCampus: -1,
  listaCampus: [],
  error: "",
  loading: false,
  loadingUltimosRecibos: false,
  loadingCartera: false,
  loadingDataSegmentos: false,
  loadingAlumnosSegmentados: false,
  loadingSendTemplate: false,
  loadingSendLinkPagoEmail: false,
  authenticatedUser: {},
  dataDashboardCobranza: {},
  dataDashboardCobranzaComparativa: {},
  dataDashboardUltimosRecibos: {},
  listaCampusLight: [],
  listaCarrerasLight: [],
  listaPlanesLight: [],
  listaTurnosLight: [],
  listaTrayectoriasLight: [],
  listaStatusLight: [],
  configuraciones: [],
  ingresosEgresos: [],
  dataSegmentos: [],
  alumnosSegmentados: [],
  resumenPuntualidad: [],
  mensajeExitoso: "",
}

const campusVirtualMachine = createMachine(
  {
    predictableActionArguments: true,
    context: initialContext,
    id: "campusVirtual",
    initial: "idle",
    states: {
      idle: {
        on: {
          "campusvirtual/RESUMENPUNTUALIDAD": {
            actions: ["unsetError", "unsetResumenPuntualidad", "setLoading"],
            target: "idle",
          },
          "campusvirtual/RESUMENPUNTUALIDADSUCCESS": {
            actions: ["unsetError", "setResumenPuntualidad", "unsetLoading"],
            target: "idle",
          },
          "campusvirtual/RESUMENPUNTUALIDADFAIL": {
            actions: ["setError", "unsetResumenPuntualidad", "unsetLoading"],
            target: "idle",
          },

          "campusvirtual/SET_MESSAGE_SUCCESS": {
            actions: ["setMensajeExitoso"],
            target: "idle",
          },
          "campusvirtual/UNSET_MESSAGE_SUCCESS": {
            actions: ["unsetMensajeExitoso"],
            target: "idle",
          },

          "campusvirtual/SENDLINKPAGOEMAIL": {
            actions: [
              "unsetError",
              "setLoading",
              "setLoadingSendLinkPagoEmail",
            ],
            target: "idle",
          },
          "campusvirtual/SENDLINKPAGOEMAILSUCCESS": {
            actions: [
              "unsetError",
              "setMensajeExitoso",
              "unsetLoading",
              "unsetLoadingSendLinkPagoEmail",
            ],
            target: "idle",
          },
          "campusvirtual/SENDLINKPAGOEMAILFAIL": {
            actions: [
              "setError",
              "unsetLoading",
              "unsetLoadingSendLinkPagoEmail",
            ],
            target: "idle",
          },

          "campusvirtual/SENDTEMPLATE": {
            actions: ["unsetError", "setLoading", "setLoadingSendTemplate"],
            target: "idle",
          },
          "campusvirtual/SENDTEMPLATESUCCESS": {
            actions: [
              "unsetError",
              "setMensajeExitoso",
              "unsetLoading",
              "unsetLoadingSendTemplate",
            ],
            target: "idle",
          },
          "campusvirtual/SENDTEMPLATEFAIL": {
            actions: ["setError", "unsetLoading", "unsetLoadingSendTemplate"],
            target: "idle",
          },
          "campusvirtual/DATASEGMENTOS": {
            actions: [
              "unsetError",
              "unsetDataSegmentos",
              "setLoading",
              "setLoadingDataSegmentos",
            ],
            target: "idle",
          },
          "campusvirtual/DATASEGMENTOSSUCCESS": {
            actions: [
              "unsetError",
              "setDataSegmentos",
              "unsetLoading",
              "unsetLoadingDataSegmentos",
            ],
            target: "idle",
          },
          "campusvirtual/DATASEGMENTOSFAIL": {
            actions: [
              "setError",
              "unsetDataSegmentos",
              "unsetLoading",
              "unsetLoadingDataSegmentos",
            ],
            target: "idle",
          },
          "campusvirtual/ALUMNOSSEGMENTADOS": {
            actions: [
              "unsetError",
              "unsetAlumnosSegmentados",
              "setLoading",
              "setLoadingAlumnosSegmentados",
            ],
            target: "idle",
          },
          "campusvirtual/ALUMNOSSEGMENTADOSSUCCESS": {
            actions: [
              "unsetError",
              "setAlumnosSegmentados",
              "unsetLoading",
              "unsetLoadingAlumnosSegmentados",
            ],
            target: "idle",
          },
          "campusvirtual/ALUMNOSSEGMENTADOSFAIL": {
            actions: [
              "setError",
              "unsetAlumnosSegmentados",
              "unsetLoading",
              "unsetLoadingAlumnosSegmentados",
            ],
            target: "idle",
          },
          "campusvirtual/INGRESOSEGRESOS": {
            actions: ["unsetError", "unsetIngresosEgresos", "setLoading"],
            target: "idle",
          },
          "campusvirtual/INGRESOSEGRESOSSUCCESS": {
            actions: ["unsetError", "setIngresosEgresos", "unsetLoading"],
            target: "idle",
          },
          "campusvirtual/INGRESOSEGRESOSFAIL": {
            actions: ["setError", "unsetIngresosEgresos", "unsetLoading"],
            target: "idle",
          },
          "campusvirtual/CONFIGURACION": {
            actions: ["unsetError", "unsetConfiguraciones", "setLoading"],
            target: "idle",
          },
          "campusvirtual/CONFIGURACIONSUCCESS": {
            actions: ["unsetError", "setConfiguraciones", "unsetLoading"],
            target: "idle",
          },
          "campusvirtual/CONFIGURACIONFAIL": {
            actions: ["setError", "unsetConfiguraciones", "unsetLoading"],
            target: "idle",
          },
          "campusvirtual/CAMPUS": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "campusvirtual/CAMPUSSUCCESS": {
            actions: ["unsetError", "setlistaCampusLight", "unsetLoading"],
            target: "idle",
          },
          "campusvirtual/CAMPUSFAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
          "campusvirtual/CARRERAS": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "campusvirtual/CARRERASSUCCESS": {
            actions: ["unsetError", "setlistaCarrerasLight", "unsetLoading"],
            target: "idle",
          },
          "campusvirtual/CARRERASFAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
          "campusvirtual/PLANES": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "campusvirtual/PLANESSUCCESS": {
            actions: ["unsetError", "setlistaPlanesLight", "unsetLoading"],
            target: "idle",
          },
          "campusvirtual/PLANESFAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
          "campusvirtual/TURNOS": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "campusvirtual/TURNOSSUCCESS": {
            actions: ["unsetError", "setlistaTurnosLight", "unsetLoading"],
            target: "idle",
          },
          "campusvirtual/TURNOSFAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
          "campusvirtual/TRAYECTORIAS": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "campusvirtual/TRAYECTORIASSUCCESS": {
            actions: [
              "unsetError",
              "setlistaTrayectoriasLight",
              "unsetLoading",
            ],
            target: "idle",
          },
          "campusvirtual/TRAYECTORIASFAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
          "campusvirtual/STATUS": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "campusvirtual/STATUSSUCCESS": {
            actions: ["unsetError", "setlistaStatusLight", "unsetLoading"],
            target: "idle",
          },
          "campusvirtual/STATUSFAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },

          "campusvirtual/WAIT_FOR_PROPERTY_TO_CHANGE": {
            target: "idle",
          },
          "campusvirtual/LOGOUT": {
            actions: ["resetMachine"],
            target: "idle",
          },
          "campusvirtual/ULTIMOSRECIBOS": {
            actions: ["unsetError", "setLoading", "setLoadingUltimosRecibos"],
            target: "idle",
          },
          "campusvirtual/ULTIMOSRECIBOSSUCCESS": {
            actions: [
              "unsetError",
              "setdataDashboardUltimosRecibos",
              "unsetLoading",
              "unsetLoadingUltimosRecibos",
            ],
            target: "idle",
          },
          "campusvirtual/ULTIMOSRECIBOSFAIL": {
            actions: ["setError", "unsetLoading", "unsetLoadingUltimosRecibos"],
            target: "idle",
          },
          "campusvirtual/CARTERA": {
            actions: ["unsetError", "setLoading", "setLoadingCartera"],
            target: "idle",
          },
          "campusvirtual/CARTERASUCCESS": {
            actions: [
              "unsetError",
              "setdataDashboardCartera",
              "unsetLoading",
              "unsetLoadinCartera",
            ],
            target: "idle",
          },
          "campusvirtual/CARTERAFAIL": {
            actions: ["setError", "unsetLoading", "unsetLoadinCartera"],
            target: "idle",
          },
          "campusvirtual/CARTERACOMPARATIVA": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "campusvirtual/CARTERACOMPARATIVASUCCESS": {
            actions: [
              "unsetError",
              "setdataDashboardCarteraComparativa",
              "unsetLoading",
            ],
            target: "idle",
          },
          "campusvirtual/CARTERACOMPARATIVAFAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
          "campusvirtual/SETIDCAMPUS": {
            actions: ["setIdCampus"],
            target: "idle",
          },
          "campusvirtual/SETLISTACAMPI": {
            actions: ["setListaCampus"],
            target: "idle",
          },
          "campusvirtual/SETLISTACONFIGURACIONES": {
            actions: ["setConfiguraciones"],
            target: "idle",
          },
          "campusvirtual/SETAUTHENTICATEDUSER": {
            actions: ["setAuthenticatedUser"],
            target: "idle",
          },
          "campusvirtual/UNSETAUTHENTICATEDUSER": {
            actions: ["unsetAuthenticatedUser"],
            target: "idle",
          },
        },
      },
    },
  },
  {
    actions: {
      resetMachine: assign(initialContext),
      setlistaCampusLight: assign({
        listaCampusLight: (_, event) => event.payload.data,
      }),
      unsetlistaCampusLight: assign({
        listaCampusLight: [],
      }),
      setConfiguraciones: assign({
        configuraciones: (_, event) => {
          return event.payload
        },
      }),
      unsetConfiguraciones: assign({
        //configuraciones: [],
      }),
      setIngresosEgresos: assign({
        ingresosEgresos: (_, event) => {
          return event.payload.data
        },
      }),
      unsetIngresosEgresos: assign({
        ingresosEgresos: [],
      }),
      setDataSegmentos: assign({
        dataSegmentos: (_, event) => {
          return event.payload.data
        },
      }),
      unsetDataSegmentos: assign({
        dataSegmentos: [],
      }), //resumenPuntualidad
      setAlumnosSegmentados: assign({
        alumnosSegmentados: (_, event) => {
          return event.payload.data
        },
      }),
      unsetAlumnosSegmentados: assign({
        alumnosSegmentados: [],
      }),
      setResumenPuntualidad: assign({
        resumenPuntualidad: (_, event) => {
          return event.payload.data
        },
      }),
      unsetResumenPuntualidad: assign({
        resumenPuntualidad: [],
      }),
      setlistaCarrerasLight: assign({
        listaCarrerasLight: (_, event) => event.payload.data,
      }),
      unsetlistaCarrerasLight: assign({
        listaCarrerasLight: [],
      }),
      setlistaPlanesLight: assign({
        listaPlanesLight: (_, event) => event.payload.data,
      }),
      unsetlistaPlanesLight: assign({
        listaPlanesLight: [],
      }),
      setlistaTurnosLight: assign({
        listaTurnosLight: (_, event) => event.payload.data,
      }),
      unsetlistaTurnosLight: assign({
        listaTurnosLight: [],
      }),
      setlistaTrayectoriasLight: assign({
        listaTrayectoriasLight: (_, event) => event.payload.data,
      }),
      unsetlistaTrayectoriasLight: assign({
        listaTrayectoriasLight: [],
      }),
      setlistaStatusLight: assign({
        listaStatusLight: (_, event) => event.payload.data,
      }),
      unsetlistaStatusLight: assign({
        listaStatusLight: [],
      }),
      setdataDashboardCartera: assign({
        dataDashboardCobranza: (_, event) => {
          return event.payload.data
        },
      }),
      setdataDashboardCarteraComparativa: assign({
        dataDashboardCobranzaComparativa: (_, event) => {
          return event.payload.data
        },
      }),
      setdataDashboardUltimosRecibos: assign({
        dataDashboardUltimosRecibos: (_, event) => {
          return event.payload.data
        },
      }),
      setNotificacion: assign({
        error: (_, event) => {
          console.log("setNotificacion")
          return ""
        },
      }),
      setIdCampus: assign({
        idCampus: (_, event) => {
          //console.log(event)
          return event.payload
        },
      }),
      unsetIdCampus: assign({
        idCampus: (_, event) => {
          //console.log(event)
          return -1
        },
      }),
      setListaCampus: assign({
        listaCampus: (_, event) => {
          //console.log(event)
          return event.payload
        },
      }),
      unsetListaCampus: assign({
        listaCampus: (_, event) => {
          //console.log(event)
          return []
        },
      }),
      setAuthenticatedUser: assign({
        authenticatedUser: (_, event) => {
          return event.payload
        },
      }),
      unsetAuthenticatedUser: assign({
        authenticatedUser: (_, event) => {
          return {}
        },
      }),
      setError: assign({
        error: (_, event) => {
          console.log(event.payload)
          return event.payload.response?.data?.Mensaje_Error
            ? event.payload.response?.data?.Mensaje_Error
            : event.payload.message
            ? event.payload.message
            : "Ocurrió un error!"
        },
      }),
      unsetError: assign({
        error: null,
      }),
      setLoading: assign({
        loading: true,
      }),
      unsetLoading: assign({
        loading: false,
      }),
      setLoadingUltimosRecibos: assign({
        loadingUltimosRecibos: true,
      }),
      unsetLoadingUltimosRecibos: assign({
        loadingUltimosRecibos: false,
      }),
      setLoadingCartera: assign({
        loadingCartera: true,
      }),
      unsetLoadingCartera: assign({
        loadingCartera: false,
      }),
      setLoadingDataSegmentos: assign({
        loadingDataSegmentos: true,
      }),
      unsetLoadingDataSegmentos: assign({
        loadingDataSegmentos: false,
      }),
      setLoadingAlumnosSegmentados: assign({
        loadingAlumnosSegmentados: true,
      }),
      unsetLoadingAlumnosSegmentados: assign({
        loadingAlumnosSegmentados: false,
      }),
      setLoadingSendTemplate: assign({
        loadingSendTemplate: true,
      }),
      unsetLoadingSendTemplate: assign({
        loadingSendTemplate: false,
      }),
      setLoadingSendLinkPagoEmail: assign({
        loadingSendLinkPagoEmail: true,
      }),
      unsetLoadingSendLinkPagoEmail: assign({
        loadingSendLinkPagoEmail: false,
      }),
      setMensajeExitoso: assign({
        mensajeExitoso: (_, event) => {
          //console.log("setMensajeExitoso:", event.payload)
          return event.payload.mensajeExitoso
        },
      }),
      unsetMensajeExitoso: assign({
        mensajeExitoso: "",
      }),
    },
  }
)

export default campusVirtualMachine
